export const T = {
  // Surfaces
  bg:          '#FAF8F5',
  surface:     '#FFFFFF',
  surfaceAlt:  '#F4EFE3',
  surfaceSel:  '#FBF6E8',

  // Borders
  border:      '#E6DFD2',
  borderSoft:  '#EFE9DB',
  borderInput: '#D9D1BE',

  // Text
  ink:         '#1F1C16',
  text:        '#2D2A24',
  textMuted:   '#6B6452',
  textSubtle:  '#8A8270',
  textFaint:   '#A9A18C',

  // Semantic
  tierTop:     '#6B5B3A',
  tierMid:     '#9A8E72',
  tierBottom:  '#B85042',
  danger:      '#B85042',
} as const;

export type Tier = 'top' | 'mid' | 'bottom';

// Deliberately NOT T.tierTop/tierMid/tierBottom (those are the muted earthy
// palette shared with unrelated UI, e.g. the "Active" status dot) — the tier
// highlight needs to read at a glance as good/neutral/concerning, so it gets
// its own clear green/amber/red scale, independent of the rest of the theme.
export const TIER_RAIL: Record<Tier, string> = {
  top:    '#2E9E5B',
  mid:    '#C99A1E',
  bottom: '#C1443A',
};

export const TIER_LABEL: Record<Tier, string> = {
  top: 'Top', mid: 'Mid', bottom: 'Bottom',
};

export function scoreFg(n: number): string {
  if (n >= 85) return T.ink;
  if (n >= 65) return T.textMuted;
  return T.danger;
}
